import { useTranslation } from 'react-i18next'

import { InviteUserForm, PermissionsUserForm } from '../components'
import { FormWizard } from '../context'

export const UserInviteWizard = () => {
  const { t } = useTranslation()

  const steps = [
    {
      title: t('users.invite'),
      component: <InviteUserForm />
    },
    {
      title: t('users.set_permissions'),
      component: <PermissionsUserForm />
    }
  ]

  return <FormWizard steps={steps} />
}
